import React, { forwardRef, useMemo } from 'react'
import Select from 'react-select'
import SelectAsync from 'react-select/async'
import SelectCreatable from 'react-select/creatable'
import cx from 'classnames'

import styles from './ReactSelect.module.css'

const NoRender = () => null

const ReactSelect = forwardRef((props, ref) => {
  const {
    className,
    creatable = false,
    loadOptions: inputLoadOptions,
    minCharsBeforeLoadingOptions = 0,
    ...rest
  } = props

  const SelectComponent = useMemo(() => {
    if (inputLoadOptions) {
      return SelectAsync
    }

    return creatable ? SelectCreatable : Select
  }, [creatable, inputLoadOptions])

  const components = useMemo(() => {
    const selectComponents = {
      ...rest.components,
      IndicatorSeparator: null
    }

    Object.entries(selectComponents).forEach(([key, value]) => {
      if (!value) {
        selectComponents[key] = NoRender
      }
    })

    return selectComponents
  }, [rest.components])

  const loadOptions = useMemo(
    () => (inputValue, callback) => {
      if (inputValue.length < minCharsBeforeLoadingOptions || typeof loadOptions !== 'function') {
        return callback(null)
      }

      return inputLoadOptions(inputValue, callback)
    },
    [minCharsBeforeLoadingOptions, inputLoadOptions]
  )

  return (
    <SelectComponent
      {...rest}
      ref={ref}
      className={cx(styles.Select, className)}
      theme={(theme) => {
        return {
          ...theme,
          colors: {
            ...theme.colors,
            primary: 'var(--primary-color)',
            primary25: 'var(--primary-color-10)'
          }
        }
      }}
      components={components}
      loadOptions={loadOptions}
      styles={{
        ...rest.styles,
        control: (provided) => ({
          ...provided,
          boxShadow: 'none'
        })
      }}
      classNamePrefix='ReactSelectExtended'
    />
  )
})

ReactSelect.displayName = 'ReactSelect'

export default ReactSelect
